import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const updateSubSmaster=({
    id,
    name,
    mobile
})=>async dispatch=>{
    dispatch({
        type:actionTypes.SUB_SMASTER_UPDATE_START
    })
    const options={
        url:`/subsmasters/${id}`,
        method:'PUT',
        data:{
            name,
            mobile
        }
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.SUB_SMASTER_UPDATE_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.SUB_SMASTER_UPDATE_FAIL,
                payload:getMessage(error)
            }))
}